import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, Event, NavigationEnd } from '@angular/router';

@Component({
  selector: 'cigna-layout-unsecure',
  templateUrl: './layout-unsecure.component.html',
  styleUrls: ['./layout-unsecure.component.scss'],
})
export class LayoutUnSecureComponent implements OnInit {
  isSiteDown: boolean;
  layoutDisableRoutes: string[] = ['/public/campaign'];
  isLayoutEnabled = true;
  constructor(private translate: TranslateService, private router: Router) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.isLayoutEnabled =
          this.layoutDisableRoutes.filter((x) => event.url.indexOf(x) >= 0)
            .length === 0;
      }
    });
  }

  ngOnInit(): void {
    const siteDown = this.translate.instant(`global.isSiteDown`);
    this.isSiteDown = siteDown === 'true';
  }
}
